// src/features/users/usersSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
  linkValid: null,
};

export const usersSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // for login
    loginLoad: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    //for referral

    userLoginLoad: (state) => {
      state.loading = true;
    },
    userLoginSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    userLoginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // for forgotPassword
    forgotPasswordLoad: (state) => {
      state.loading = true;
    },
    forgotPasswordSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    forgotPasswordFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    //create-password
    createPasswordLoad: (state, action) => {
      state.loading = true;
    },

    createPasswordSuccess: (state, action) => {
      state.loading = false;
    },

    createPasswordFailure: (state, action) => {
      state.loading = false;
    },

    signUpLoad: (state, action) => {
      state.loading = true;
    },

    signUpSuccess: (state, action) => {
      state.loading = false;
    },

    signUpFailure: (state, action) => {
      state.loading = false;
    },

    otpLoad: (state, action) => {
      state.loading = true;
    },

    otpSuccess: (state, action) => {
      state.loading = false;
    },

    otpFailure: (state, action) => {
      state.loading = false;
    },

    webTokenLoad: (state, action) => {
      state.loading = true;
    },

    webTokenSuccess: (state, action) => {
      state.loading = false;
    },

    webTokenFailue: (state, action) => {
      state.loading = false;
    },
    //// change-password

    changePasswordLoad: (state) => {},

    changePasswordSuccess: (state, action) => {},

    changePasswordFail: (state, action) => {},

    skipApiLoad: (state) => {},
    skipApiSuccess: (state) => {},

    //// link verify api ///////
    checkLinkLoad: (state) => {
      state.loading = true;
    },

    checkLinkSuccess: (state) => {
      state.loading = false;
      state.linkValid = true;
    },

    checkLinkFail: (state) => {
      state.loading = false;
      state.linkValid = false;
    },

    ///// reset Password api ///////

    resetPasswordLoad: (state) => {
      state.loading = true;
    },

    resetPasswordSuccess: (state) => {
      state.loading = false;
    },

    resetPasswordFailure: (state) => {
      state.loading = false;
    },

    ///////// logut Api ///////////////

    logoutLoad: (state) => {
      state.loading = true;
    },
    logoutSuccess: (state) => {
      state.loading = false;
    },
    logoutFailure: (state) => {
      state.loading = false;
    },
  },
});
export const {
  loginLoad,
  loginSuccess,
  loginFailure,
  userLoginLoad,
  userLoginSuccess,
  userLoginFailure,
  forgotPasswordLoad,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  checkLinkLoad,
  checkLinkSuccess,
  checkLinkFail,
  resetPasswordLoad,
  resetPasswordFailure,
  resetPasswordSuccess,
  logoutLoad,
  logoutSuccess,
  logoutFailure,
  changePasswordLoad,
  createPasswordLoad,
  createPasswordSuccess,
  createPasswordFailure,
  changePasswordSuccess,
  changePasswordFail,
  skipApiLoad,
  skipApiSuccess,
  signUpLoad,
  signUpSuccess,
  signUpFailure,
  otpLoad,
  otpSuccess,
  otpFailure,
  webTokenLoad,
  webTokenFailue,
  webTokenSuccess
} = usersSlice.actions;

export default usersSlice.reducer;
